module.exports = __webpack_public_path__ + "img/small_truck_red.2296b8e3.svg";